<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="wcrd_bus_own_priv_lic"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >CHECK ON WARRANT STATUS
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <v-card-title>
            <h4>Visit the following sites to check on warrant status.</h4>
          </v-card-title>
          <v-card-text>
            <div>
              <a
                class="mt-3"
                href="https://www.reno.gov/government/municipal-court/find-your-case"
                target="_blank"
                >RENO MUNICIPAL COURT</a
              >
            </div>
            <div class="mt-3">
              <a
                href="https://justicecourts.washoecounty.us/Public/default.aspx"
                target="_blank"
                >RENO JUSTICE COURT</a
              >
            </div>
            <div class="mt-3">
              <a
                href="https://www.washoecourts.com/Query/PersonSearch"
                target="_blank"
                >SECOND JUDICIAL DISTRICT COURT</a
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
a_big_blue {
  font-size: 1.1rem;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter2_img {
    max-width: 877px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_warrant_status",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
